import { cn } from "@/shared/lib/utils"

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn(
				"relative overflow-hidden rounded-md bg-primary/10",
				"after:absolute after:inset-0 after:bg-gradient-to-r after:from-transparent after:via-white/[0.07] after:to-transparent after:content-['']",
				"motion-safe:after:animate-[skeleton-sweep_1.6s_ease-in-out_infinite]",
				className,
			)}
			{...props}
		/>
	)
}

export { Skeleton }
